import { render, staticRenderFns } from "./CheckScreeningForm.vue?vue&type=template&id=4b0987e9&scoped=true&"
import script from "./CheckScreeningForm.vue?vue&type=script&lang=js&"
export * from "./CheckScreeningForm.vue?vue&type=script&lang=js&"
import style0 from "./CheckScreeningForm.vue?vue&type=style&index=0&id=4b0987e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0987e9",
  null
  
)

export default component.exports